/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";

interface OwnProps {
    title: string;
    wishListId: string;
    testSelector: string;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        customerId: state.pages.myLists.getWishListsParameter.customerId,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const MyListsDetailsPageTypeLink: React.FunctionComponent<Props> = ({
    title,
    wishListId,
    testSelector,
    customerId,
}) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            testSelector,
            pageType: "MyListsDetailsPage",
            overrideTitle: title,
            queryString: `id=${wishListId}${customerId ? `&customerId=${customerId}` : ""}`,
        },
    });
};

export default connect(mapStateToProps, null)(MyListsDetailsPageTypeLink);
